import { useCallback } from 'react';

import {
    getResolvedPlanTier,
    hasFeatureAddOnAccess,
    hasGatedFeatureAccess,
    hasMinimumPlanAccess,
} from '@/shared/entitlements';
import { useUserStore } from '@/stores';
import { useBillingStore } from '@/stores/database/aliases/billing';
import { GatedFeatureKey, PlanTier } from '@/stores/database/aliases/billing/types';

export const useEntitlements = () => {
    const fallbackPlan = useUserStore((state) => state.selectedUser?.plan);
    const snapshot = useBillingStore((state) => state.snapshot);
    const planTier = getResolvedPlanTier(snapshot, fallbackPlan);

    return {
        planTier,
        snapshot,
        hasFeatureAddOn: useCallback(
            (featureAddOn: 'lifecycles' | 'relations') => hasFeatureAddOnAccess(snapshot, featureAddOn),
            [snapshot],
        ),
        hasFeature: useCallback((feature: GatedFeatureKey) => hasGatedFeatureAccess(snapshot, feature), [snapshot]),
        hasMinimumPlan: useCallback(
            (minimum: PlanTier) => hasMinimumPlanAccess(snapshot, minimum, fallbackPlan),
            [fallbackPlan, snapshot],
        ),
    };
};
